import React, { useState, useEffect, useRef } from 'react';
import "./Header.scss"

import mainLogoWhite from "../../Assets/images/main-logo-white.svg"
import ccIcon from "../../Assets/images/cc-icon.svg"
import tcIcon from "../../Assets/images/tc-icon.svg"
import hsIcon from "../../Assets/images/hs-icon.svg"

const navLinks = [
  { href: '#home', label: 'HOME' },
  { href: '#about', label: 'ABOUT US' },
  { href: '#contact', label: 'CONTACT US' },
];

const SCROLL_THRESHOLD = 10;

const Header = ({ onSignUpClick, onSignInClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeHash, setActiveHash] = useState(window.location.hash || '#home');
  const [headerHidden, setHeaderHidden] = useState(false);
  const headerRef = useRef(null);
  const lastScrollY = useRef(0);
  const rafScheduled = useRef(false);

  useEffect(() => {
    const onHashChange = () => setActiveHash(window.location.hash || '#home');
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (rafScheduled.current) return;
      rafScheduled.current = true;
      requestAnimationFrame(() => {
        const currentY = window.scrollY;
        const delta = currentY - lastScrollY.current;
        if (delta > SCROLL_THRESHOLD && currentY > 0) {
          setHeaderHidden(true);
        } else if (delta < -SCROLL_THRESHOLD) {
          setHeaderHidden(false);
        }
        lastScrollY.current = currentY;
        rafScheduled.current = false;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileMenuOpen) setHeaderHidden(false);
  }, [mobileMenuOpen]);

  useEffect(() => {
    if (!mobileMenuOpen) return;

    const handleOutsideClick = (e) => {
      if (headerRef.current && !headerRef.current.contains(e.target)) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [mobileMenuOpen]);

  return (
    <header ref={headerRef} className={`header-top${mobileMenuOpen ? ' nav-open' : ''}${headerHidden ? ' header-hidden' : ''}`}>
      <div className="container header-container">
        <div className="ht-left">
          <a href="/" className="ht-logo">
            <img src={mainLogoWhite} alt="HaulSync Logo" />
          </a>
        </div>

        <nav className="ht-center">
          {navLinks.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              className={`nav-link-item${activeHash === href ? ' active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="ht-right">
          <div className="dropdown h-drop">
            <a
              className="dropdown-toggle hd-btn-signup"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              SIGN UP
            </a>
            <ul className="dropdown-menu hd-menu hd-menu-signup">
              <div className="id-inner">
                <ul>
                  <li>
                    <a href="#" onClick={(e) => { e.preventDefault(); onSignUpClick('cc'); }}>
                      <img className="drop-icon" src={ccIcon} alt="" />
                      Construction Company
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={(e) => { e.preventDefault(); onSignUpClick('tc'); }}>
                      <img className="drop-icon" src={tcIcon} alt="" />
                      Truck Company
                    </a>
                  </li>
                </ul>
              </div>
            </ul>
          </div>

          <div className="dropdown h-drop">
            <a
              className="dropdown-toggle hd-btn-signin"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              SIGN IN
            </a>
            <ul className="dropdown-menu hd-menu hd-menu-signin">
              <div className="id-inner">
                <ul>
                  <li>
                    <a href="#" onClick={(e) => { e.preventDefault(); onSignInClick('cc'); }}>
                      <img className="drop-icon" src={ccIcon} alt="" />
                      Construction Company
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={(e) => { e.preventDefault(); onSignInClick('tc'); }}>
                      <img className="drop-icon" src={tcIcon} alt="" />
                      Truck Company
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={(e) => { e.preventDefault(); onSignInClick('hs'); }}>
                      <img className="drop-icon" src={hsIcon} alt="" />
                      HaulSync
                    </a>
                  </li>
                </ul>
              </div>
            </ul>
          </div>
        </div>

        <button
          className={`hamburger-btn${mobileMenuOpen ? ' is-open' : ''}`}
          onClick={() => setMobileMenuOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
          <span className="hamburger-bar" />
        </button>
      </div>

      {mobileMenuOpen && (
        <div className="mobile-nav-panel">
          <nav className="mobile-nav-links">
            {navLinks.map(({ href, label }) => (
              <a
                key={href}
                href={href}
                className={`mobile-nav-link${activeHash === href ? ' active' : ''}`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {label}
              </a>
            ))}
          </nav>
          <div className="mobile-nav-actions">
            <div className="dropdown">
              <a
                className="dropdown-toggle hd-btn-signup mobile-auth-btn"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                SIGN UP
              </a>
              <ul className="dropdown-menu hd-menu hd-menu-signup">
                <div className="id-inner">
                  <ul>
                    <li>
                      <a href="#" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); onSignUpClick('cc'); }}>
                        <img className="drop-icon" src={ccIcon} alt="" />
                        Construction Company
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); onSignUpClick('tc'); }}>
                        <img className="drop-icon" src={tcIcon} alt="" />
                        Truck Company
                      </a>
                    </li>
                  </ul>
                </div>
              </ul>
            </div>
            <div className="dropdown">
              <a
                className="dropdown-toggle hd-btn-signin mobile-auth-btn"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                SIGN IN
              </a>
              <ul className="dropdown-menu hd-menu hd-menu-signin">
                <div className="id-inner">
                  <ul>
                    <li>
                      <a href="#" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); onSignInClick('cc'); }}>
                        <img className="drop-icon" src={ccIcon} alt="" />
                        Construction Company
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); onSignInClick('tc'); }}>
                        <img className="drop-icon" src={tcIcon} alt="" />
                        Truck Company
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick={(e) => { e.preventDefault(); setMobileMenuOpen(false); onSignInClick('hs'); }}>
                        <img className="drop-icon" src={hsIcon} alt="" />
                        HaulSync
                      </a>
                    </li>
                  </ul>
                </div>
              </ul>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;

